<div class="one height-525 state-height" [formGroup]="SettingForm" fxLayout="column">
  <h3 class="mb-3 text-[14px]">
    <b>Define easily editable statements for your Invoices & Costs Agreements</b>
  </h3>
  <h3 class="text-[14px]">
    Think of the statements as your T&C's. The Invoice has three separate paragraphs already coded
    onto the invoice - you can edit the text here.
    <br />
    The Global Footer by default will appear on the bottom of all correspondence including emails.
  </h3>
  <br />
  <div class="border-line"></div>
  <div class="w-full">
    <mat-tab-group>
      <mat-tab label="Invoice">
        <br />
        <h3 class="mb-3 text-[14px]">PDF Invoice Templates ONLY:</h3>
        <h3 class="text-[14px]">
          Do you want to format the Statements on your invoice using things like bold, italics,
          bullet points etc? If so, use the RTF option.
          <br />
          We recommend you prepare the statements in a word processor such as Microsoft Word® or
          Wordpad and then save it as RTF. Then upload that RTF file here.
          <br />
          <strong>Files should be no more than 64K in size</strong>
        </h3>
        <br />
        <!-- <div class="border-line"></div>  -->
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <div class="flex w-full items-center">
            <mat-slide-toggle
              class="toggle-statement"
              formControlName="STATEMENT2ISRTF"
              (change)="UseRTFToggle1($event)"
            >
              Use RTF
            </mat-slide-toggle>
            <div class="statment-insert">
              <!-- <strong  *ngIf="this.SettingForm.controls['STATEMENT2ISRTF'].value && this.SettingForm.controls['STATEMENT2'].value" class="color-gray" > {{'*The RTF has been set for this statement. If you would like to change it upload another RTF file'}} </strong>

              <strong  *ngIf="this.SettingForm.controls['STATEMENT2ISRTF'].value && !this.SettingForm.controls['STATEMENT2'].value"  class="color-red"> {{'*The RTF has not been set for this statement. Please upload an RTF file to set it'}} </strong> -->
              <!-- <mat-form-field class="padding-bottom-0"
              *ngIf="!this.SettingForm.controls['STATEMENT2ISRTF'].value"
              appearance="outline" fxFlex="100"
              [ngClass]="{'has-error':errorWarningData.Error?.STATEMENT2,'has-warning':errorWarningData.Warning?.STATEMENT2}">
              <textarea matInput name="STATEMENT2"
              formControlName="STATEMENT2"></textarea>
            </mat-form-field> -->

              @if (!this.SettingForm.controls['STATEMENT2ISRTF'].value) {
                <mat-form-field
                  appearance="outline"
                  class="full-width mb-4 pr-1"
                  fxFlex="100"
                  [ngClass]="{
                    'has-error': $safeNavigationMigration(errorWarningData?.Error?.STATEMENT2),
                    'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.STATEMENT2),
                  }"
                >
                  <mat-label>Statement 2</mat-label>

                  <textarea
                    matInput
                    name="STATEMENT2"
                    formControlName="STATEMENT2"
                    rows="2"
                    (keydown.enter)="$event.stopImmediatePropagation()"
                  ></textarea>
                </mat-form-field>
              }
              @if (this.SettingForm.controls['STATEMENT2ISRTF'].value) {
                <div
                  class="dropzone"
                  appFileDragNDrop
                  (filesChangeEmiter)="onFileChange($event, 'UseRTFToggleOne')"
                >
                  <div class="text-wrapper">
                    <div class="centered">
                      <input
                        type="file"
                        name="file_0"
                        id="file_0"
                        (change)="onFileChange($event.target.files, 'UseRTFToggleOne')"
                        accept="rtf/*"
                      />
                      @if (!this.SettingForm.controls['STATEMENT2RTFFILE'].value) {
                        <label for="file_0">
                          <span class="textLink">
                            <mat-icon style="position: relative; top: 4px; right: 4px">
                              cloud_upload
                            </mat-icon>
                            Select your file
                          </span>
                          or Drop it here!
                        </label>
                      }
                      <span
                        class="flex w-full justify-center"
                        [ngClass]="
                          this.SettingForm.controls['STATEMENT2RTFFILE'].value
                            ? 'statement-inpname'
                            : 'statement-inpname-none'
                        "
                      >
                        <p class="flex items-center">
                          {{ this.SettingForm.controls['STATEMENT2RTFFILE'].value }}
                          @if (this.SettingForm.controls['STATEMENT2RTFFILE'].value) {
                            <mat-icon
                              class="cursor pl-2"
                              (click)="remove('UseRTFToggleOne', 'file_0')"
                            >
                              cancel
                            </mat-icon>
                          }
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <div class="flex w-full items-center">
            <mat-slide-toggle
              class="toggle-statement"
              formControlName="STATEMENT3ISRTF"
              (change)="UseRTFToggle2($event)"
            >
              Use RTF
            </mat-slide-toggle>
            <div class="statment-insert">
              <!-- <strong  *ngIf="this.SettingForm.controls['STATEMENT3ISRTF'].value && this.SettingForm.controls['STATEMENT3'].value"  class="color-gray"> {{'*The RTF has been set for this statement. If you would like to change it upload another RTF file'}} </strong>

                <strong  *ngIf="this.SettingForm.controls['STATEMENT3ISRTF'].value && !this.SettingForm.controls['STATEMENT3'].value"  class="color-red"> {{'*The RTF has not been set for this statement. Please upload an RTF file to set it'}} </strong> -->
              <!-- <mat-form-field class="padding-bottom-0"
                *ngIf="!this.SettingForm.controls['STATEMENT3ISRTF'].value"
                appearance="outline" fxFlex="100"
                [ngClass]="{'has-error':errorWarningData.Error?.STATEMENT3 ,'has-warning':errorWarningData.Warning?.STATEMENT3 }">
                <textarea matInput name="STATEMENT3"
                formControlName="STATEMENT3"></textarea>
              </mat-form-field> -->

              @if (!this.SettingForm.controls['STATEMENT3ISRTF'].value) {
                <mat-form-field
                  appearance="outline"
                  class="full-width mb-4 pr-1"
                  fxFlex="100"
                  [ngClass]="{
                    'has-error': $safeNavigationMigration(errorWarningData?.Error?.STATEMENT3),
                    'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.STATEMENT3),
                  }"
                >
                  <mat-label>Statement 3</mat-label>

                  <textarea
                    matInput
                    name="STATEMENT3"
                    formControlName="STATEMENT3"
                    rows="2"
                    (keydown.enter)="$event.stopImmediatePropagation()"
                  ></textarea>
                </mat-form-field>
              }
              @if (this.SettingForm.controls['STATEMENT3ISRTF'].value) {
                <div
                  class="dropzone"
                  appFileDragNDrop
                  (filesChangeEmiter)="onFileChange($event, 'UseRTFToggleTwo')"
                >
                  <div class="text-wrapper">
                    <div class="centered">
                      <input
                        type="file"
                        name="file_1"
                        id="file_1"
                        (change)="onFileChange($event.target.files, 'UseRTFToggleTwo')"
                        accept="rtf/*"
                      />
                      @if (!this.SettingForm.controls['STATEMENT3RTFFILE'].value) {
                        <label for="file_1">
                          <span class="textLink">
                            <mat-icon style="position: relative; top: 4px; right: 4px">
                              cloud_upload
                            </mat-icon>
                            Select your file
                          </span>
                          or Drop it here!
                        </label>
                      }
                      <span
                        class="flex justify-center"
                        [ngClass]="
                          this.SettingForm.controls['STATEMENT3RTFFILE'].value
                            ? 'statement-inpname'
                            : 'statement-inpname-none'
                        "
                      >
                        <p>
                          {{ this.SettingForm.controls['STATEMENT3RTFFILE'].value }}
                          @if (this.SettingForm.controls['STATEMENT3RTFFILE'].value) {
                            <mat-icon
                              class="cursor pl-2"
                              (click)="remove('UseRTFToggleTwo', 'file_1')"
                            >
                              cancel
                            </mat-icon>
                          }
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <div class="flex w-full items-center">
            <mat-slide-toggle
              class="toggle-statement"
              formControlName="STATEMENT4ISRTF"
              (change)="UseRTFToggle3($event)"
            >
              Use RTF
            </mat-slide-toggle>
            <div class="statment-insert">
              <!-- <strong  *ngIf="this.SettingForm.controls['STATEMENT4ISRTF'].value && this.SettingForm.controls['STATEMENT4'].value"  class="color-gray"> {{'*The RTF has been set for this statement. If you would like to change it upload another RTF file'}} </strong>

              <strong  *ngIf="this.SettingForm.controls['STATEMENT4ISRTF'].value && !this.SettingForm.controls['STATEMENT4'].value"  class="color-red"> {{'*The RTF has not been set for this statement. Please upload an RTF file to set it'}} </strong> -->

              <!-- <mat-form-field class="padding-bottom-0"
              *ngIf="!this.SettingForm.controls['STATEMENT4ISRTF'].value"
              appearance="outline" fxFlex="100"
              [ngClass]="{'has-error':errorWarningData.Error?.STATEMENT4,'has-warning':errorWarningData.Warning?.STATEMENT4}">
              <textarea matInput name="STATEMENT4"
              formControlName="STATEMENT4"></textarea>
            </mat-form-field> -->

              @if (!this.SettingForm.controls['STATEMENT4ISRTF'].value) {
                <mat-form-field
                  appearance="outline"
                  class="full-width mb-4 pr-1"
                  fxFlex="100"
                  [ngClass]="{
                    'has-error': $safeNavigationMigration(errorWarningData?.Error?.STATEMENT4),
                    'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.STATEMENT4),
                  }"
                >
                  <mat-label>Statement 4</mat-label>

                  <textarea
                    matInput
                    name="STATEMENT4"
                    formControlName="STATEMENT4"
                    rows="2"
                    (keydown.enter)="$event.stopImmediatePropagation()"
                  ></textarea>
                </mat-form-field>
              }
              @if (this.SettingForm.controls['STATEMENT4ISRTF'].value) {
                <div
                  class="dropzone"
                  appFileDragNDrop
                  (filesChangeEmiter)="onFileChange($event, 'UseRTFToggleThree')"
                >
                  <div class="text-wrapper">
                    <div class="centered">
                      <input
                        type="file"
                        name="file_2"
                        id="file_2"
                        (change)="onFileChange($event.target.files, 'UseRTFToggleThree')"
                        accept="rtf/*"
                      />
                      @if (!this.SettingForm.controls['STATEMENT4RTFFILE'].value) {
                        <label for="file_2">
                          <span class="textLink">
                            <mat-icon style="position: relative; top: 4px; right: 4px">
                              cloud_upload
                            </mat-icon>
                            Select your file
                          </span>
                          or Drop it here!
                        </label>
                      }
                      <span
                        class="flex justify-center"
                        [ngClass]="
                          this.SettingForm.controls['STATEMENT4RTFFILE'].value
                            ? 'statement-inpname'
                            : 'statement-inpname-none'
                        "
                      >
                        <p>
                          {{ this.SettingForm.controls['STATEMENT4RTFFILE'].value }}
                          @if (this.SettingForm.controls['STATEMENT4RTFFILE'].value) {
                            <mat-icon
                              class="cursor pl-2"
                              (click)="remove('UseRTFToggleThree', 'file_2')"
                            >
                              cancel
                            </mat-icon>
                          }
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div>
          <mat-dialog-actions class="popup_ftr justify-end!">
            <button
              class="mainbtn_size"
              matButton="filled"
              [disabled]="isspinerIS"
              (click)="saveInvoiceStatements()"
            >
              @if (isspinerIS) {
                <mat-spinner diameter="24"></mat-spinner>
              }
              Save
            </button>
            <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
          </mat-dialog-actions>
        </div>
      </mat-tab>
      <mat-tab label="Global Footer">
        <br />
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="100"
              [ngClass]="{'has-error':errorWarningData.Error?.STATEMENT5,'has-warning':errorWarningData.Warning?.STATEMENT5}">
              <textarea matInput name="STATEMENT5"
              formControlName="STATEMENT5"></textarea>
            </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            class="full-width pr-1"
            fxFlex="100"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData?.Error?.STATEMENT5),
              'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.STATEMENT5),
            }"
          >
            <mat-label>Statement 5</mat-label>

            <textarea
              matInput
              name="STATEMENT5"
              formControlName="STATEMENT5"
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-dialog-actions class="popup_ftr justify-end!">
            <button
              class="mainbtn_size"
              matButton="filled"
              [disabled]="isspinerFooter"
              (click)="saveGlobalFooter()"
            >
              @if (isspinerFooter) {
                <mat-spinner diameter="24"></mat-spinner>
              }
              Save
            </button>
            <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
          </mat-dialog-actions>
        </div>
      </mat-tab>
      <mat-tab label="Costs Agreement">
        <br />
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="100"
                [ngClass]="{'has-error':errorWarningData.Error?.MATTER,'has-warning':errorWarningData.Warning?.MATTER}">
                <textarea matInput name="FEEAGREEMENTSTATEMENT"
                formControlName="FEEAGREEMENTSTATEMENT"></textarea>
              </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            class="full-width pr-1"
            fxFlex="100"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData?.Error?.MATTER),
              'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.MATTER),
            }"
          >
            <mat-label>Fee Agreement Statement</mat-label>

            <textarea
              matInput
              name="FEEAGREEMENTSTATEMENT"
              formControlName="FEEAGREEMENTSTATEMENT"
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-dialog-actions align="end" class="popup_ftr">
            <button
              class="mainbtn_size"
              matButton="filled"
              [disabled]="isspinerCost"
              (click)="saveCostAgreement()"
            >
              @if (isspinerCost) {
                <mat-spinner diameter="24"></mat-spinner>
              }
              Save
            </button>
            <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
          </mat-dialog-actions>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      class="mainbtn_size"
      matButton="filled"
      [disabled]="isspiner"
      (click)="saveStatements()"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
